import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import api from "../../api-axios";
import showReport from "../../showReport";

const template = {
    dataInicial: undefined,
    dataFinal: undefined,
    canceladas: false,
    ordenarPorFaturamento: undefined    
};

export default class RankingNfse extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...template };

        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);

        this.ordenacaoOptions = {
            searchEnabled: false,
            dataSource: [
                { id: true, descricao: "FATURAMENTO" },
                { id: false, descricao: "QTDE DE NOTAS" },
            ],
            valueExpr: "id",
            displayExpr: "descricao",
        }

        this.canceladasOptions = {
            searchEnabled: false,
            dataSource: [
                { id: false, descricao: "ATIVAS" },
                { id: true, descricao: "CANCELADAS" },
            ],
            valueExpr: "id",
            displayExpr: "descricao",
        }
    }

    componentDidMount() {
        const dataCorrente = new Date();
        this.setState({
            dataFinal: dataCorrente,
            canceladas: false,
            ordenarPorFaturamento: true
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className={"content-block dx-card responsive-paddings"}>
                    <Form formData={this.state} colCount={1}>
                        <GroupItem caption="Ranking de Faturamento/Emissão de Notas por Cpbs" >
                            <SimpleItem
                                dataField={"dataInicial"}
                                editorType={"dxDateBox"}
                                editorOptions={{ width: "100%" , useMaskBehavior: true}}>
                                <Label text="Data Inicial" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={"dataFinal"}
                                editorType={"dxDateBox"}
                                editorOptions={{ width: "100%" , useMaskBehavior: true}}>
                                <Label text="Data Final" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={"ordenarPorFaturamento"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.ordenacaoOptions}>
                                <Label text="Ordenar Por"/>
                            </SimpleItem>

                            <SimpleItem
                                dataField={"canceladas"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.canceladasOptions}>
                                <Label text="Tipo de Notas"/>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <div
                        style={{
                            display: "flex",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={150}
                                text="Voltar"
                                icon="back"
                                onClick={() => this.cancel()}
                            />
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "10px" }}>
                            <Button
                                width={150}
                                text="Imprimir"
                                type="success"
                                icon={"print"}
                                onClick={this.ok}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    ok() {
        const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
        console.log(entidade);
        showReport("/report/ranking_nfse", entidade);
    }

    cancel() {
        if (this.props.location.origem != undefined) {
            const origem = this.props.location.origem;
            this.props.history.push(origem);
        }
        else {
            this.props.history.goBack();
        }
    }
}
